import { combineReducers } from 'redux';
import { usersListReducer } from './reducers/users-list-reducer';
import { welldesignUsersListReducer } from './reducers/welldesign-list-reducer';
import { externalUsersRequestsReducer } from './reducers/external-users-requests';
import userDatasetSlice  from './reducers/user-dataset.slice';

export default combineReducers({
  usersListReducer,
  welldesignUsersListReducer,
  userDatasetSlice,
  externalUsersRequestsReducer,
});
